import styled from 'styled-components';

export const LegendWrapper = styled.div`
  display: flex;
`;

export const LegendLabel = styled.div`
  margin-right: 16px;
`;
